import React from 'react';
import {graphql, useMutation} from 'react-relay/hooks';
import classNames from 'classnames';
import Currency from '../../../../components/currency/currency';
import {useAuthorizationState} from '../../../../contexts/Authorization';
import {getRecaptchaToken} from '../../../../utils/recaptcha';

const StemLikeButton = React.memo(({postId, stemLikesCount, isStemLiked, isAuthorized, isOwnPost, isSharedPost, onShowLoginPrompt, onShowBalanceError, onHideBalanceError}) => {

    const [stemLikePost, isStemLikingPost] = useMutation(
        graphql`
            mutation stemLikeButtonStemLikeVibePostMutation(
                $request: StemLikeVibePostRequestInput!
                $includePostAuthor: Boolean!
                $includeOriginalAuthor: Boolean!
            ) {
                stemLikeVibePost(request: $request) {
                    id
                    user {
                        id
                        balance
                        pending {
                            hash
                            amount
                        }
                    }
                    post {
                        id
                        stemLikesCount
                        stemLikedByCurrentUser
                        author @include(if: $includePostAuthor) {
                            id
                            balance
                            pending {
                                hash
                                amount
                            }
                        }
                        sharedPost @include(if: $includeOriginalAuthor) {
                            author {
                                id
                                balance
                                pending {
                                    hash
                                    amount
                                }
                            }
                        }
                    }
                }
            }
        `
    );

    const handleStemLikeClick = async () => {
        if (!isAuthorized) {
            onShowLoginPrompt?.();
            return;
        }

        try {
            const reCaptcha = await getRecaptchaToken();
            stemLikePost({
                variables: {
                    request: {postId: postId, reCaptcha},
                    includePostAuthor: !isSharedPost, // For regular/quoted posts, include post author
                    includeOriginalAuthor: isSharedPost // For shared posts, include original author
                },
                onCompleted: () => {
                    onHideBalanceError?.();
                },
                onError: (error) => {
                    onShowBalanceError?.();
                }
            });
        } catch (error) {
            console.error('reCAPTCHA error:', error);
        }
    };

    return (
        <button
            onClick={isOwnPost ? undefined : handleStemLikeClick}
            disabled={isStemLikingPost || isOwnPost}
            className={classNames(
                'display-flex align-items-center column-gap-0dot5rem background-color-transparent border-style-none padding-0 padding-bottom-0dot25rem border-bottom-style-solid border-bottom-width-0dot125rem border-bottom-color-transparent',
                {
                    'cursor-pointer': !isStemLikingPost && !isOwnPost,
                    'opacity-0dot5 cursor-not-allowed': isStemLikingPost
                }
            )}
        >
            <Currency
                isStem={true}
                theme='plain'
                stemIconClasses={classNames('display-block width-1dot25rem height-1dot25rem', {
                    'color-success-500': isStemLiked,
                    'color-gray-400': !isStemLiked
                })}
            />
            <span className={classNames('text-sm', {
                'color-success-500 semibold': isStemLiked,
                'color-gray-500': !isStemLiked
            })}>
                {(stemLikesCount || 0)}{isStemLikingPost ? '...' : ''}
            </span>
        </button>
    );
});

export default StemLikeButton;

